import Style from "../scss/text.module.scss";

export function TitleH2Component(props) {
    return (
        <h2 className={`${Style.h2} ${props.styleGroup}`}>{props.children}</h2>
    );
}